export const getFirstName = (fullName: string): string => {
  if (!fullName) return 'Nome Desconhecido'
  const parts = fullName.trim().split(/[\s-]+/)

  return parts[0] + ' ' + parts[1]
}
